import React from 'react'

const Footer = () => {
  return (
    <div>
      This is footer
    </div>
  )
}

export default Footer
